module.exports = __webpack_public_path__ + "img/info_center_icon1.7312ddae.jpg";